<template>
    <div class="meter-batch-rechargin-box">
        <div class="energy-data-query-left">
            <div class="left-item">
                <el-form>
                    <el-row style="height: 2rem">
                        <el-col>
                            <el-input v-model="filterText" size="mini" >
                                <template slot="prepend">用户名称/编号</template>
                            </el-input>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 1rem;height: 2rem">
                        <el-col align="center">
                            <el-radio-group v-model="meterType" size="mini" >
                                <el-radio-button label="2">电表</el-radio-button>
                                <el-radio-button label="1">水表</el-radio-button>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="tree" >
                <el-container>
                    <flex>
                        <el-main ref="elMain" style="height: calc(100vh - 17rem)">
                            <el-tree
                                    class="filter-tree"
                                    :data="energyUnitTree"
                                    node-key="id"
                                    show-checkbox
                                    :default-expanded-keys="expandedKey"
                                    :filter-node-method="filterNode"
                                    :highlight-current="true"
                                    @node-click="click"
                                    @check="check"
                                    :expand-on-click-node="false"
                                    ref="tree"
                                    style="background-color: #fafafa; min-width: 100%;display:inline-block;"
                            >
                            </el-tree>
                        </el-main>
                    </flex>
                </el-container>
            </div>
            <div align="center">
                <el-button size="mini" type="primary" @click="addMeterToForm" style="width: 30%">添加</el-button>
            </div>
        </div>
        <div class="energy-data-query-right">
            <div class="customerUsersMeter-condition-box" style="padding-left: 1rem;padding-top: 0.6rem">
                <el-form :inline="true" size="mini">
                    <el-form-item label="批量充值金额：">
                        <el-input v-model="rechargeAmount" style="width: 120px" size="mini" @blur="monitorAmount"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;元
                    </el-form-item>
                    <el-form-item>
                        <el-button type="danger" @click="removeAll">全部移除</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="div-hr"></div>
            <div>
                <flex>

                    <div class="meter-table-box" style="height: calc(100vh - 15rem)">
                        <el-table :data="customerUserMeterArr" :header-row-style="{color:'black'}" size="mini"
                                  height="100%" width="100%"
                                  stripe
                                  highlight-current-row
                                  @filter-change="handleFilterChange"
                                  @row-click="">
                            <el-table-column
                                    align="center"
                                    prop="customerUserRealName"
                                    label="业主用户名称">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="customerUserName"
                                    label="业主用户编号">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="meterName"
                                    label="仪表名称">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="meterCode"
                                    label="仪表编号">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="customerEnergyId"
                                    label="能源类型">
                                <template slot-scope="scope">
                                    <span>{{ formatCustomerEnergy(scope.row.customerEnergyId) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="balance"
                                    label="余额（元）">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.balance === null ? '--': numberFormat2(scope.row.balance) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="充值余额（元）">
                                <template slot-scope="scope">
                                    <span>{{ numberFormat2(rechargeAmount) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="afterBalance"
                                    label="充值后表内余额（元）">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.afterBalance === null ? '--': numberFormat2(scope.row.afterBalance) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="accountStatus"
                                    label="开户状态"
                                    column-key="accountStatus"
                                    :filters="[{ text: '启用', value: 1 }, { text: '停用', value: 0 }]"
                                    >
                                <template slot-scope="scope">
                                    <span>{{ scope.row.accountStatus === null ? '--' : scope.row.accountStatus === 1 ? '启用' : '停用' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="快速充值">
                                <template slot-scope="scope">
                                    <el-button type="text" size="mini" @click="quickRecharge(scope.row)"
                                               :disabled="scope.row.meterTypeId === '2d49e0b5-f37d-11e8-9c8f-0235d2b38928' || scope.row.meterTypeId === '2d8c39b8-8cd1-524d-bbec-d3a3daa94f7b' || scope.row.meterTypeId === '69e51132-fefb-5b60-b5a8-9164176467d8'/*水表或非预付费仪表*/
                                               ? scope.row.rechargeResult === 2 || scope.row.rechargeResult === 0 || scope.row.warningTypeId === 'af4521c7-6ffe-4d98-b3bb-eef78e85a879' || scope.row.warningTypeId === 'f05a0c7d-0468-421c-ad73-1ce3928a6333'/*采集器通讯中断或仪表通讯中断*/
                                               : scope.row.rechargeResult === 2 || scope.row.rechargeResult === 0 || scope.row.warningTypeId === 'af4521c7-6ffe-4d98-b3bb-eef78e85a879' || scope.row.warningTypeId === 'f05a0c7d-0468-421c-ad73-1ce3928a6333'/*采集器通讯中断或仪表通讯中断*/ || scope.row.accountStatus === 0">
                                        <div>
                                            <svg-icon icon-class="快速充值"></svg-icon>充值
                                        </div>
                                    </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="rechargeResult"
                                    label="充值结果"
                                    column-key="rechargeResult"
                                    :filters="[{ text: '未充值', value: null }, { text: '充值成功', value: 0 }, { text: '充值失败', value: 1 }, { text: '充值中', value: 2 }]"
                                    >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.rechargeResult === null" >未充值</span>
                                    <span v-if="scope.row.rechargeResult === 0" style="color: green">充值成功</span>
                                    <span v-if="scope.row.rechargeResult === 1" style="color: red">充值失败</span>
                                    <span v-if="scope.row.rechargeResult === 2" style="color: #00a5b2">充值中</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="移除列表">
                                <template slot-scope="scope">
                                    <el-button @click="customerUserMeterRemove(scope.row)" size="mini" circle icon="el-icon-minus" ></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div><!--展示-->
                </flex>
                <div class="page-box">
                    <el-pagination
                            background
                            @size-change="customerUserMeterSizeChange"
                            @current-change="customerUserMeterCurrentChange"
                            :current-page="customerUserMeterPage.current"
                            :page-sizes="[20, 50, 100, 500, 1000]"
                            :page-size="customerUserMeterPageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="customerUserMeterPage.total">
                    </el-pagination>
                </div><!--分页-->
            </div>
        </div>
    </div>

</template>

<script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import {uuidWithoutLine} from "@/utils/uuid";
  import { tree, expandedCustomerWithMeter } from '@/utils/energyUtilTree'
  import { getCustomerUserMeterInfo } from "@/api/meterbatchRecharge";
  import {getCustomerEenrgies} from "@/api/customerEnergy";
  import {quickRecharge} from "@/api/rechargeRecord";
  import { WS } from '@/utils/ws'
  import Flex from "@/components/Flex";

  export default {
    name: 'meterManage',
    components: {Flex},
    data() {
      return {
        filterText: '',
        energyUnitTree: [], /* 能耗单元树*/
        meterType: 2,
        expandedKey: [], // 展开的节点id
        checkedMeterIds: new Map(),
        activeMeterIds: new Map(),
        rechargeAmount: 0,
        customerUserMeter: [],//全部数据
        customerUserMeterArr: [],//分页数据
        customerUserMeterByPage: [],//加了筛选条件的数据
        customerUserMeterPage: {}, /* 分页对象*/
        customerUserMeterCurrentPage: 1,
        customerUserMeterPageSize: 20,
        customerEnergies: [],
        accountStatusFilter: null,
        rechargeResultFilter: null,
        batchRechargeSubscribe: {}
      }
    },
    computed: {
      ...mapGetters([
        'customerId',
        'userId',
        'customerUserMeterInfos',
        'batchRechargeAmount'
      ])
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val)
      },
      meterType() { // 监听能源类型变化
        this.getEnergyUnitTree()
      },
    },
    mounted() {
      this.getEnergyUnitTree()
      this.fetchCustomerEnergies()
      if(this.customerUserMeterInfos !== null && this.customerUserMeterInfos.length > 0){
          //分页
        var size = typeof this.customerUserMeterPage.size === 'undefined' ? this.customerUserMeterPageSize : this.customerUserMeterPage.size
        var page = typeof this.customerUserMeterPage.current === 'undefined' ? this.customerUserMeterCurrentPage : this.customerUserMeterPage.current
        var start = size*(page-1)
        var end = size*(page)
        this.customerUserMeterArr = this.customerUserMeterInfos.slice(start,end)
        this.customerUserMeterPage.total = this.customerUserMeterInfos.length
        this.customerUserMeterPage.size = size
        this.customerUserMeterPage.current = page

        this.customerUserMeter = this.customerUserMeterInfos
      }
      this.rechargeAmount = this.batchRechargeAmount

      this.batchRechargeSubscribe = new WS();
      this.batchRechargeSubscribe.connect(res => {
        this.batchRechargeSubscribe.subscribe("/topic/batchRecharge/"+this.userId, (val) => {//读取仪表参数订阅，若接收到内容，因报停调用的读取仪表参数内容更新信息
          debugger
          let message = JSON.parse(val.body)
          let rechargeRecord = message.result
          for(var i = 0; i < this.customerUserMeterInfos.length; i ++){
            if(rechargeRecord.meter_id === this.customerUserMeterInfos[i].meterId){
              if(rechargeRecord.status === 2){
                this.customerUserMeterInfos[i].rechargeResult = 0
              }else{
                this.customerUserMeterInfos[i].rechargeResult = 1
              }
            }
          }
        })
      }, err => {

      })
    },
      destroyed(){
          // 清除订阅记录
        if (this.batchRechargeSubscribe && this.batchRechargeSubscribe.connected) {
          this.batchRechargeSubscribe.disconnect()
        }

      },
    methods: {
      numberFormat2: function(value){
        value = Math.round(value * Math.pow(10, 2)) / Math.pow(10, 2); //四舍五入
        value = Number(value).toFixed(2); //补足位数
        return value;

      },
      handleFilterChange: function(filters){
        this.customerUserMeterByPage = []
        if(typeof filters.accountStatus !== 'undefined' && filters.accountStatus !== null){
          this.accountStatusFilter = filters.accountStatus
        }
        if(typeof filters.rechargeResult !== 'undefined' && filters.rechargeResult !== null){
          this.rechargeResultFilter = filters.rechargeResult
        }
        this.customerUserMeterArr = []//清除分页数据
        if(this.accountStatusFilter === null && this.rechargeResultFilter === null){
          this.customerUserMeterByPage = this.customerUserMeter
        }else if(this.accountStatusFilter === null && this.rechargeResultFilter.length === 0){
          this.customerUserMeterByPage = this.customerUserMeter
        }else if(this.accountStatusFilter === null && this.rechargeResultFilter.length > 0){
          for(var i = 0; i < this.customerUserMeter.length; i ++){
            for(var j = 0; j < this.rechargeResultFilter.length; j ++) {
              if (this.customerUserMeter[i].rechargeResult === this.rechargeResultFilter[j]) {
                this.customerUserMeterByPage.push(this.customerUserMeter[i])
              }
            }
          }
        }else if(this.accountStatusFilter.length === 0 && this.rechargeResultFilter === null){
          this.customerUserMeterByPage = this.customerUserMeter
        }else if(this.accountStatusFilter.length > 0 && this.rechargeResultFilter === null){
          for(var i = 0; i < this.customerUserMeter.length; i ++){
            for(var j = 0; j < this.accountStatusFilter.length; j ++){
              if(this.customerUserMeter[i].accountStatus === this.accountStatusFilter[j]){
                this.customerUserMeterByPage.push(this.customerUserMeter[i])
              }
            }
          }
        }else if(this.accountStatusFilter.length === 0 && this.rechargeResultFilter.length === 0){
          this.customerUserMeterByPage = this.customerUserMeter
        }else if(this.accountStatusFilter.length > 0 && this.rechargeResultFilter.length === 0){
          for(var i = 0; i < this.customerUserMeter.length; i ++){
            for(var j = 0; j < this.accountStatusFilter.length; j ++){
              if(this.customerUserMeter[i].accountStatus === this.accountStatusFilter[j]){
                this.customerUserMeterByPage.push(this.customerUserMeter[i])
              }
            }
          }
        }else if(this.accountStatusFilter.length === 0 && this.rechargeResultFilter.length > 0){
          for(var i = 0; i < this.customerUserMeter.length; i ++){
            for(var j = 0; j < this.rechargeResultFilter.length; j ++) {
              if (this.customerUserMeter[i].rechargeResult === this.rechargeResultFilter[j]) {
                this.customerUserMeterByPage.push(this.customerUserMeter[i])
              }
            }
          }
        }else{
          for(var i = 0; i < this.customerUserMeter.length; i ++){
            for(var j = 0; j < this.accountStatusFilter.length; j ++){
              if(this.customerUserMeter[i].accountStatus === this.accountStatusFilter[j]){
                for(var m = 0; m < this.rechargeResultFilter.length; m ++) {
                  if (this.customerUserMeter[i].rechargeResult === this.rechargeResultFilter[m]) {
                    this.customerUserMeterByPage.push(this.customerUserMeter[i])
                  }
                }
              }
            }
          }
        }
        this.customerUserMeterPage.current = 1
        this.customerUserMeterPage.total = this.customerUserMeterByPage.length
        //切换到该页
        var size = typeof this.customerUserMeterPage.size === 'undefined' ? this.customerUserMeterPageSize : this.customerUserMeterPage.size
        this.customerUserMeterArr = this.customerUserMeterByPage.slice(0,size)
      },
      removeAll: function(){
        this.customerUserMeter = []//清除全部数据
        this.customerUserMeterArr = []//清除分页数据
        this.customerUserMeterPage = []//清除分页对象
        this.rechargeAmount = 0
        this.$store.commit('SET_BATCH_CRECHARGE_AMOUNT',0)//更新store中的数据
        this.$store.commit('SET_CUSTOMER_USER_METER_INFOS',[])//更新store中的数据
      },
      quickRecharge: function(customerUserMeter){
        if(parseFloat(this.rechargeAmount)===0){
          Message({
            type: 'error',
            message: '请输入合理的充值金额'
          })
          return
        }
        var uuid = uuidWithoutLine()
        var commandId = uuidWithoutLine()
        quickRecharge(uuid, commandId, customerUserMeter.meterId, this.rechargeAmount, 'cashpay', 'batchRecharge',
          customerUserMeter.customerId, this.userId, customerUserMeter.customerUserId).then(response => {
          if(response.code==200){
            //修改充值状态
            customerUserMeter.rechargeResult = 2
            Message({
              message: '充值中，请稍候'
            })
          }else{
            Message({
              type: 'error',
              message: response.message
            })
          }
        }).catch(error => {
          Message({
            type: 'error',
            message: '充值失败'
          })
        })
      },
      monitorAmount: function(){//监控充值金额的变化
        let reg=/^([0-9]+|[0-9]{1,3}(,[0-9]{3})*)(.[0-9]{1,2})?$/
        if(!reg.test(this.rechargeAmount)){
          Message({
            type: 'error',
            message: '请输入合理的充值金额'
          })
          return
        }
        this.$store.commit('SET_BATCH_CRECHARGE_AMOUNT',0)
        for(var i = 0; i < this.customerUserMeter.length; i ++){
          if(this.customerUserMeter[i].balance != null){
            this.customerUserMeter[i].afterBalance = Math.round((parseFloat(this.customerUserMeter[i].balance) + parseFloat(this.rechargeAmount))*100)/100
          }else{
            this.customerUserMeter[i].afterBalance = Math.round(parseFloat(this.rechargeAmount)*100)/100
          }
        }
        this.$store.commit('SET_BATCH_CRECHARGE_AMOUNT',this.rechargeAmount)//更新store中的数据
        this.$store.commit('SET_CUSTOMER_USER_METER_INFOS',this.customerUserMeter)//更新store中的数据
      },
      customerUserMeterRemove: function(customerUserMeter){//删除
        //分页
        var size = typeof this.customerUserMeterPage.size === 'undefined' ? this.customerUserMeterPageSize : this.customerUserMeterPage.size
        var page = typeof this.customerUserMeterPage.current === 'undefined' ? this.customerUserMeterCurrentPage : this.customerUserMeterPage.current
        var start = size*(page-1)
        var end = size*(page)

        for(var i = 0; i < this.customerUserMeterInfos.length; i ++){
          if(this.customerUserMeterInfos[i].meterId === customerUserMeter.meterId){
            this.customerUserMeter.splice(i,1)
          }
        }

        this.customerUserMeterArr = this.customerUserMeter.slice(start,end)
        this.customerUserMeterPage.total = this.customerUserMeter.length
        this.customerUserMeterPage.size = size
        this.customerUserMeterPage.current = page

        this.$store.commit('SET_CUSTOMER_USER_METER_INFOS',this.customerUserMeter)//更新store中的数据
      },
      addMeterToForm: function(){
        if(this.checkedMeterIds.size === 0){
          Message({
            message: '请选择仪表',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        var meterIds = []
        for(var o of this.checkedMeterIds){
          meterIds.push(o[0])
        }
        if (this.customerUserMeterPage.total) this.customerUserMeterPage.total = null
        var condition = {meterIds: meterIds, customerId: this.customerId}
        this.fetchMeters(condition)
      },
      fetchMeters: function(condition){
        getCustomerUserMeterInfo(condition).then(res => {
          if(res.code === 200){
            if(this.customerUserMeterInfos.length === 0){//缓存中无数据
              this.customerUserMeter = res.infoJson
              this.$store.commit('SET_CUSTOMER_USER_METER_INFOS',res.infoJson)
              this.customerUserMeterPage.total = this.customerUserMeter.length
              //切换到该页
              var start = this.customerUserMeterPageSize*(this.customerUserMeterCurrentPage-1)
              var end = this.customerUserMeterPageSize*(this.customerUserMeterCurrentPage)
              this.customerUserMeterArr = this.customerUserMeter.slice(start,end)
            }else{//缓存中有数据
              const customerUserMeter = res.infoJson
              for(var i = 0; i < customerUserMeter.length; i ++){
                var flag = true
                for(var j = 0; j < this.customerUserMeterInfos.length; j ++){
                  if(this.customerUserMeterInfos[j].meterId === customerUserMeter[i].meterId){
                    flag = false
                    break//相同的，结束内层循环
                  }
                }
                if(flag){
                  var customerUserMeterInfosTemp = []
                  for(var j = 0; j < this.customerUserMeterInfos.length; j ++){
                    customerUserMeterInfosTemp.push(this.customerUserMeterInfos[j])
                  }
                  customerUserMeterInfosTemp.push(customerUserMeter[i])
                  //分页
                  var size = typeof this.customerUserMeterPage.size === 'undefined' ? this.customerUserMeterPageSize : this.customerUserMeterPage.size
                  var page = typeof this.customerUserMeterPage.current === 'undefined' ? this.customerUserMeterCurrentPage : this.customerUserMeterPage.current
                  var start = size*(page-1)
                  var end = size*(page)
                  this.customerUserMeterArr = customerUserMeterInfosTemp.slice(start,end)
                  this.customerUserMeterPage.total = customerUserMeterInfosTemp.length
                  this.customerUserMeterPage.size = size
                  this.customerUserMeterPage.current = page
                    console.table(this.customerUserMeterInfos)
                  this.$store.commit('SET_CUSTOMER_USER_METER_INFOS',customerUserMeterInfosTemp)
                    console.table(this.customerUserMeterInfos)
                  this.customerUserMeter = []
                  this.customerUserMeter = customerUserMeterInfosTemp
                }
              }
            }
          }else{
            Message({
              message: '业主用户仪表查询失败',
              type: 'warning',
              duration: 5 * 1000
            })
            this.meter = []
          }
        })
      },
      getEnergyUnitTree() {
        this.checkedMeterIds.clear()
        const customerId = this.customerId
        //const approachIds = [approachId]
        tree(customerId, null, null, this.meterType).then(response => {
          if (response !== null || response !== undefined) {
            this.energyUnitTree = response[0].children
            //获取第一个含有仪表能耗单元的节点id集合
            const keys = expandedCustomerWithMeter(this.energyUnitTree)
            this.expandedKey.push(keys[0].customerId)
          }
        }).catch(error => {
          this.energyUnitTree = []
          this.$message({
            type: 'error',
            message: '能耗单元树查询失败'
          })
          console.log(error)
        })
      },
      filterNode(value, data) { //data.id + ''转字符串,number类型报错
        let flag=false;
        if (!value){
          flag=true;
        }else{
          if(data.type==1){ // 1 是用户
            if(data.label!==null&&data.label.indexOf(value) !== -1){
              flag=true;
            }else if(data.code!==null&&data.code.indexOf(value) !== -1){
              flag=true;
            }else{
              flag=false
            }
          }
          if(data.type==2){ // 2 是仪表
            if(data.father.name!==null&&data.father.name.indexOf(value) !== -1){
              flag=true;
            }else if(data.father.code!==null&&data.father.code.indexOf(value) !== -1){
              flag=true;
            }else{
              flag=false
            }
          }
        }
        return flag;
      },
      click(data, node) { // 节点点击事件
        if(node.checked){
          node.setChecked(false)
          if(typeof data.typeId !== 'undefined' && data.typeId !== null && data.typeId !== ''){
            if(this.checkedMeterIds.has(data.typeId)){
              this.checkedMeterIds.delete(data.typeId)
            }
          }
        }else{
          node.setChecked(true)//点击后选中该节点
          if(typeof data.type !== 'undefined' && data.type !== null && data.type === 2){//将选中的仪表添加到id集合中
            this.checkedMeterIds.set(data.typeId,data.typeId)
          }
        }
      },
      check(data,status){
        this.checkedMeterIds.clear()
        if(status.checkedNodes.length > 0){//选中
          for(var i = 0; i < status.checkedNodes.length; i ++){
            if(typeof status.checkedNodes[i].type !== 'undefined' && status.checkedNodes[i].type !== null && status.checkedNodes[i].type === 2){//将选中的仪表添加到id集合中
              this.checkedMeterIds.set(status.checkedNodes[i].typeId,status.checkedNodes[i].typeId)
            }
          }
        }

      },
      checkChannge(node,checked,childrenChecked){
      },
      fetchMeterId(node){
        if(typeof node.type !== 'undefined' && node.type !== null && node.type === 2){
          this.activeMeterIds.set(node.typeId,node.typeId)
        }else{
          if(typeof node.children !== 'undefined' && node.children !== null){
            for(var i = 0; i < node.children.length; i ++){
              this.fetchMeterId(node.children[i])
            }
          }
        }
      },
      fetchCustomerEnergies: function () {//查询客户能源分类分项信息
        var customerId = this.customerId
        getCustomerEenrgies(customerId).then(res => {
          if(res.code === 200){
            this.customerEnergies =  res.infoJson
          }
        })
      },
      formatCustomerEnergy: function(customerEnergyId) {//格式化能源分类分项
        if (typeof customerEnergyId !== 'undefined' && customerEnergyId !== null && customerEnergyId !== '') {
          if(typeof this.customerEnergies !== 'undefined' && this.customerEnergies !== null && this.customerEnergies.length > 0){
            for(var i = 0; i < this.customerEnergies.length; i ++){
              if(customerEnergyId === this.customerEnergies[i].id){
                return this.customerEnergies[i].name
              }
            }
          }
        } else {
          return '未知'
        }
      },
      customerUserMeterSizeChange: function(size) {
        this.customerUserMeterPage.size = size
        //切换到该页
        var page = typeof this.customerUserMeterPage.current === 'undefined' ? this.customerUserMeterCurrentPage : this.customerUserMeterPage.current
        var start = size*(page-1)
        var end = size*(page)
        if(this.accountStatusFilter !== null || this.rechargeResultFilter !== null || this.customerUserMeterByPage.length > 0){
          this.customerUserMeterArr = this.customerUserMeterByPage.slice(start,end)
          this.customerUserMeterPage.total = this.customerUserMeterByPage.length
        }else{
          this.customerUserMeterArr = this.customerUserMeter.slice(start,end)
          this.customerUserMeterPage.total = this.customerUserMeter.length
        }
        //this.fetchMeter()
      },
      customerUserMeterCurrentChange: function(customerUserMeterCurrentPage) {
        this.customerUserMeterPage.current = customerUserMeterCurrentPage
        //切换到该页
        var size = typeof this.customerUserMeterPage.size === 'undefined' ? this.customerUserMeterPageSize : this.customerUserMeterPage.size
        var start = size*(customerUserMeterCurrentPage-1)
        var end = size*(customerUserMeterCurrentPage)
        if(this.accountStatusFilter !== null || this.rechargeResultFilter !== null || this.customerUserMeterByPage.length > 0){
          this.customerUserMeterArr = this.customerUserMeterByPage.slice(start,end)
          this.customerUserMeterPage.total = this.customerUserMeterByPage.length
        }else{
          this.customerUserMeterArr = this.customerUserMeter.slice(start,end)
          this.customerUserMeterPage.total = this.customerUserMeter.length
        }
        //this.fetchMeter()
      },
    }
  }
</script>
<style scoped rel="stylesheet/scss" lang="scss">
    .meter-batch-rechargin-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        font-size: 10px;


        .demo-table-expand .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 20%;
        }
        .energy-data-query-left {
            width: 20%;
            .left-item {
                align-items: center;
                padding-top: 5px;
                .el-form-item {
                }
            }
            .tree {
                margin-top: 5px;
                padding-bottom: 5px;
                background-color: white;

            }

        }
        .energy-data-query-right {
            padding-left: 10px;
            width: 80%;
            .content {
                display: flex;
                flex-direction: column;
                width: 100%;
                .content-table {
                    padding-top: 5px;
                    width: 100%;
                }
            }
            .page-box {
                //height: 45px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

    }
</style>
